export const SETTINGS_SET = 'SETTINGS_SET'
export const SETTINGS_SHOW_HEADER = 'SETTINGS_SHOW_HEADER'
